import {Injectable} from '@angular/core';
import {ApiService} from '@abstract/api.service';

@Injectable()
export class UsersApiService extends ApiService {
    baseUrl = 'organization-user';

    inviteUserUrl = this.baseUrl + '/invite';
    blockUserUrl = this.baseUrl + '/block';
    repeatInviteUserUrl = this.baseUrl + '/repeat-invite';
    activateUserUrl = this.baseUrl + '/unblock';

    /**
     * Путь для смены роли пользователя
     * @param userId
     */
    getChangeRolePath(userId: number) {
        return `${this.baseUrl}/${userId}/change-role`;
    }
}
